module.exports = __webpack_public_path__ + "4af687af1a8e6940d682fecd974f4d4f.svg";